import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['The volunteer or parent who got handed a team', 'Flag coaches running 5v5 or 7v7', 'Youth tackle coaches, roughly ages 6–14', 'New girls’ flag programs getting off the ground', 'Anyone who knows football but not how to run a practice'];
const notForYou = ['Varsity programs with a full coaching staff', 'Teams already running film software and their own system', 'Coaches who want playbooks only, with no practice plan'];
export function WhoFor() {
  return <section aria-labelledby="whofor-heading" className="w-full bg-ice text-ink" data-id="element-329" data-mp="5z015qo8ga5e">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-330" data-mp="3o4wao5poqzks">
        <div className="text-center" data-id="element-331" data-mp="3t3zfpq5o15sr">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-332" data-mp="3t2xuisuxr2xb">
            Before you buy
          </p>
          <h2 id="whofor-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-333" data-mp="2csloii5g61pb">
            Is Sideline Ready for you?
          </h2>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-334" data-mp="3fxx5jn8b7ymk">
          <div className="rounded-2xl border border-ice-dark bg-white p-6 shadow-card" data-id="element-335" data-mp="3fzhzbamsvdjd">
            <h3 className="font-display text-lg uppercase tracking-wide text-turf" data-id="element-336" data-mp="3uwiszjojxikh">
              Built for
            </h3>
            <ul className="mt-4 grid gap-3" data-id="element-337" data-mp="3py7kpddwng4d">
              {forYou.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-ink" data-id="element-338" data-mp="7of19xboegub">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-turf/15" data-id="element-339" data-mp="2qlxfaxuhyx7">
                    <CheckIcon className="h-3 w-3 text-turf" aria-hidden="true" data-id="element-340" data-mp="hi4elc2fxzi5" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border border-ice-dark bg-white p-6 shadow-card" data-id="element-341" data-mp="qen4effdl7ai">
            <h3 className="font-display text-lg uppercase tracking-wide text-ink-muted" data-id="element-342" data-mp="mgz38un3aia6">
              Not built for
            </h3>
            <ul className="mt-4 grid gap-3" data-id="element-343" data-mp="yh5svxmu47b8">
              {notForYou.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-ink-soft" data-id="element-344" data-mp="13giekf1yz8c8">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-ink/5" data-id="element-345" data-mp="188a54pl4le2d">
                    <XIcon className="h-3 w-3 text-ink-muted" aria-hidden="true" data-id="element-346" data-mp="1c8ajka885p9f" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}